import { ALERT_TYPE } from "components/common/Alert";
import ContentTitle from "components/common/ContentTitle";
import { useStyles } from "components/request-document/components/Commons";
import UploadDucument from "components/request-document/components/UploadDucument";
import usePersonalDetail from "components/request-document/hooks/usePersonalDetail";
import useSmartForm from "components/request-document/hooks/useSmartForm";
import useSmartService from "components/request-document/hooks/useSmartService";
import { SMART_T_STEP } from "libs/constant/Step";
import useAlert from "libs/hooks/useAlert";
import useModalLoading from "libs/hooks/useModalLoading";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { selectM24SwitchMode } from "redux/modules/m24SwitchModeSlice";
import { setSmartFormStep } from "redux/modules/uiSlice";
import {
  getDocumentRequired,
  reqdoclogList,
  reqdoclogListSlice,
  selectCurrentSmartServiceId,
  selectReqdoclogList,
} from "redux/modules/visaForm";

export default function UploadDucumentStep() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { smartserviceId: smartserviceIds } = useSmartService();

  const { showAlert, hideAlert } = useAlert();
  const { personalId } = usePersonalDetail();
  const {
    draftId,
    addSmartFormState,
    getSmartForm,
    isTypeChange,
    isDepartmentRequestDoc,
    ConditionType,
  } = useSmartForm();
  const canEdit = useSelector(canEditForm);
  const { showLoading, hideLoading } = useModalLoading();
  const reqdoclogListState = useSelector(selectReqdoclogList);
  const m24SwitchMode = useSelector(selectM24SwitchMode);
  const smartserviceId = useSelector(selectCurrentSmartServiceId);

  // const smartserviceId =
  //   M24_CONFIG_DOC[M24_CONFIG_COMPANY_TO_PERSON[m24SwitchMode]]
  //     ?.SMART_SERVICE_ID ?? null;
  // const ConditionType =
  //   M24_CONFIG_DOC[M24_CONFIG_COMPANY_TO_PERSON[m24SwitchMode]]
  //     ?.CONDITION_TYPE ?? null;

  useEffect(() => {
    if (smartserviceId) {
      dispatch(
        getDocumentRequired({
          smartserviceId,
          ConditionType,
          ...(isTypeChange && { ConditionType: "CHANGE" }),
        })
      );
      if (isDepartmentRequestDoc) {
        dispatch(reqdoclogList({ draftId, status: "R" }));
      }
      getSmartForm({
        smartserviceId,
        draftId,
        personalId,
      });
    }
  }, [
    dispatch,
    draftId,
    getSmartForm,
    personalId,
    smartserviceId,
    isDepartmentRequestDoc,
  ]);

  useEffect(() => {
    if (!reqdoclogListState.isLoading) {
      if (reqdoclogListState.isSuccess) {
        if (reqdoclogListState.list.length === 0) {
          showAlert({
            type: ALERT_TYPE.SUCCESS,
            title: "Update complete",
            description: "You have been uploaded document successfully",
            button: [
              {
                title: "Done",
                onClick: () => {
                  hideAlert();
                  dispatch(setSmartFormStep(SMART_T_STEP.NONE));
                  dispatch(reqdoclogListSlice.actions.clearAsyncState());
                },
              },
            ],
          });
        } else {
          getSmartForm({
            smartserviceId,
            draftId,
            personalId,
          });
        }
      } else if (reqdoclogListState.isFailure) {
        alert(reqdoclogListState.error?.message);
        dispatch(reqdoclogListSlice.actions.clearAsyncState());
      }
    }
  }, [reqdoclogListState, dispatch]);

  const handleOnUploaded = async () => {
    if (isDepartmentRequestDoc) {
      await dispatch(reqdoclogList({ draftId, status: "R" }));
    }
  };

  return (
    <div className={classes.root}>
      <ContentTitle
        title="Application Form"
        subTitle="APPLICATION FOR QUALIFICATION FOREIGN EXPERTS OR TECHNICIAN UNDER SECTION 24"
      />

      {/* <Steper currentStep={2} stepInfo={REQUEST_DOCUMENT_STEP} /> */}
      <UploadDucument
        isBypassAccept
        hideSummary
        onUploaded={handleOnUploaded}
      />
    </div>
  );
}
